import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import NavbarCharity from "../layout/NavbarCharity";
import FooterCharity from "../layout/FooterCharity";
import { Title } from "../components/charity/title";
import Carousel from "../components/Carousel";

function Charity1() {
  const [articleContent, setArticleContent] = useState({});
  const [slider, setSlider] = useState([]);
  const [pagePath, SetPagePath] = useState("");
  let location = useLocation();

  useEffect(() => {
    let searchParams = new URLSearchParams(location.search);
    let id = searchParams.get("id");
    SetPagePath(id);

    axios
      .post("/api/website/getCharity", { id: id * 1 })
      .then((response) => {
        const pageData = response.data.data.data;
        document.title = pageData.title;
        setArticleContent(pageData);
      })
      .catch((error) => {
        console.error("Error fetching article content:", error);
      });

    axios
      .post("/api/website/getCharitySlider", { id: id * 1 })
      .then((response) => {
        const list = response.data?.data?.slider || [];
        setSlider(list);
      })
      .catch((error) => {
        console.error("Error fetching charity slider:", error);
      });
  }, [location.search]);

  return (
    <>
      <NavbarCharity path={pagePath} charityName={articleContent.title} />
      <main className="relative">
        <section className="h-[250px] m-auto page-title flex items-center justify-center">
          <Title title={"協會簡介"} subTitle={"Introduction"} />
        </section>
        <section className="flex gap-10 max-w-[770px] w-[90%] mx-auto py-24 table:py-16 mobile:py-10">
          <div className="leading-loose text-[#373737]">
            <div className="border-l-8 border-subTitle pl-3 mb-14 table:mb-12 mobile:mb-11">
              <h2 className="text-5xl text-title mb-2 table:text-4xl mobile:text-3xl">
                {articleContent.title}
              </h2>
              <h3 className="text-2xl text-subTitle">Introduction</h3>
            </div>
            <div dangerouslySetInnerHTML={{ __html: articleContent.content }}></div>
          </div>
        </section>
        {Array.isArray(slider) && slider.length > 0 ? (
          <section className="mx-auto px-8 table:px-6 mobile:px-4 mb-16 max-w-[1300px]">
            <Carousel
              items={slider.map((s) => ({ type: s.fileType === "video" ? "video" : "image", src: s.fileURL, alt: s.title || "" }))}
              autoplay={false}
              aspectClassName="aspect-[1920/1080]"
            />
          </section>
        ) : null}
      </main>
      <FooterCharity />
    </>
  );
}

export default Charity1;
